import {CircularProgress} from '@mui/material';
import React from 'react';

export const StyledCircularProgress = () => {
    return <CircularProgress
        style={{
            position: 'absolute',
            top: '40%',
            left: '40%',
            width: '20%',
            height: 'auto',
        }}
    />;
};
